export default "__VITE_ASSET__BqKj3trL__"